// Sets viewport dimensions using verge on shared state
// and detects mobile or desktop state.

import state from '../config/state';
import { MOBILE_BREAKPOINT } from '../config/options';
import { viewportH, viewportW } from '../utils/verge';

export default function viewportDims() {
	state.v_height = viewportH();
	state.v_width = viewportW();

	if (state.v_width >= MOBILE_BREAKPOINT) {
		state.is_desktop = true;
		state.is_mobile = false;
	} else {
		state.is_desktop = false;
		state.is_mobile = true;
	}
}
